import React from 'react';
import { useHistory } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/bill-success.svg';


interface Props extends PropsFromRedux {}

const OrderSuccessful: React.FC<Props> = ({ hideModal, showModal, modal }) => {
  
  const history = useHistory();
  const closeModal = () => {
    hideModal();
    history.push('/');
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-2 bg-white lg:px-5 py-10 relative">
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={checkImg} alt="GIG App" className="w-28 my-4" />
    </div>
     <div className="w-full my-6 text-center">
         <h2 className="mb-1 text-lg font-medium text-black">Order placed successfully</h2>
         <p>Your tracking ID will be sent to you when the merchant confirms your order.</p>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Continue</button>

  </div>
  );
  // </ModalWrapper>
};

export default OrderSuccessful;